import axios from 'axios';
import * as actionTypes from '../constants/actions';
import { push } from 'redux-router';

import baseUrl from '../utils/baseUrl';

let busy = false;

function requestData() {
	return { type: actionTypes.CASES_REQ_DATA };
};

export function clearAction() {
	return { type: actionTypes.CASES_CLEAR_DATA };
};

function receiveData(type, json) {
	return {
		type: type,
		payload: json,
	};
};

function receiveError(json) {
	return {
		type: actionTypes.CASES_RECV_ERROR,
		payload: json,
	};
};

// export function fetchWinners(offset = 0, limit = 36)
// {
// 	//@TODO Implement for real when API is ready
// 	return function(dispatch) {
// 		receiveData(actionTypes.CASES_RECV_DATA_CONT, response.data)
// 	}
// }

export function fetchContCases(offset = 0, limit = 36, month = null, year = null, q = '') {
	let queryParams = {
		offset: offset,
		limit: limit,
		month: month,
		year: year,
		q: q,
	};

	if (busy) {
		return function(dispatch) {
			false;
		};
	}

	return function(dispatch) {
		busy = true;
		return axios({
			url: baseUrl + '/api/cases/',
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: queryParams,
		})
		.then(function(response) {
			dispatch(receiveData(actionTypes.CASES_RECV_DATA_CONT, response.data));
			busy = false;
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));

			console.log('fetchContCases fetch error');
			console.log(response);
			busy = false;

			//dispatch(pushState(null, '/error'));
		});
	};
};

export function fetchCases(offset = 0, limit = 20) {
	let queryParams = {
		offset: offset,
		limit: limit,
	};

	return function(dispatch) {
		dispatch(requestData());
		return axios({
			url: baseUrl + '/api/cases/',
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: queryParams,
		})
		.then(function(response) {
			dispatch(receiveData(actionTypes.CASES_RECV_DATA, response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));

			console.log('caseS fetch error');
			console.log(response.data);

			//dispatch(push('/error'));
		});
	};
};

export function fetchSingleCase(slug, preview = false) {
	if (!(typeof slug === 'number' || (typeof slug === 'string' && slug.length))) {
		console.log('cases - invalid slug');
		return function(dispatch) {
			//dispatch(pushState(null, '/error'));
		};
	}

	//console.log('fetch single case - ' + slug);

	return function(dispatch) {
		dispatch(requestData());
		let data = {};

		if (preview) {
			data.preview = preview;
		}

		return axios({
			url: baseUrl + '/api/cases/' + slug,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: data,
		})
		.then(function(response) {
			dispatch(receiveData(actionTypes.CASES_RECV_SINGLE_DATA, response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));

			console.log('case fetch error');
			console.log(response);

			dispatch(push('/error'));
		});
	};
}



/** WEBPACK FOOTER **
 ** ./frontend/actions/cases.js
 **/